import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import NavigationLink from "../../components/NavigationLink/NavigationLink";
import { EditActions, editActions } from "../../actions/editActions";
import { PdApiActions, pdApiActions } from "../../actions/pdApiActions";
import { ColumnActions, columnActions } from "../../actions/columnActions";
import {
  editedObjectIdSelector,
  isEditActiveSelector,
  editedObjectIdentifierSelector,
  domainSelector
} from "../../reducers/editReducer";
//import SignalizationParametersTable from "./Parameters/SignalizationParametersTable";
import SignalizationFaultsTable from "./Faults/SignalizationFaultsTable";
import {
  setFaultExtraProperties,
  //setParameterExtraProperties,
  //createEmptyParameter,
  createEmptyFault
} from "../../utils/pdApiUtils";
import ContentLayout from "../../components/ContentLayout/ContentLayout";
import { ActionMenu } from "../common/ActionMenu/ActionMenu";
import { mainActions } from "../../actions/mainActions";
import { Filter } from "../../components/Table/Migration/LegacyTypes";
type StateProps = {
  pdApi: State.PdApi;
  fetchingStatus: string | undefined;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  domainName: string;
  toggleChildView: State.ToggleChildView;
  isLoadingParameters: boolean;
  isLoadingFaults: boolean;
  filterOptions: State.FilterOptions;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
  columnActions: typeof columnActions;
  editActions: typeof editActions;
  mainActions: typeof mainActions;
};

type OwnProps = {
  subMenuRoute: State.SignalizationSubmenu;
};

// Props of the component
export type SignalizationProps = StateProps & DispatchProps & OwnProps;

type SignalizationState = {
  isModalOpen: boolean;
  tableColumnFilters: {
    [key in State.SignalizationSubmenu]: Filter[];
  };
};

export class Signalization extends React.Component<SignalizationProps, SignalizationState> {
  state = {
    isModalOpen: false,
    tableColumnFilters: {
      //"Signalization Parameters": [],
      "Signalization Faults": []
    }  };
  private groupName: Api.GroupName = "Signalization";
  /**
   * To add new sub page to this parent, add it here
   */
  subPages: Internal.SubPages = {
    /*"Signalization Parameters": {
      itemName: "parameter",
      PdApiField: "signalizationParameters",
      dataView: SignalizationParametersTable,
      createEmpty: createEmptyParameter,
      setExtraProperties: setParameterExtraProperties
    },*/
    "Signalization Faults": {
      itemName: "fault",
      PdApiField: "signalizationFaults",
      dataView: SignalizationFaultsTable,
      createEmpty: createEmptyFault,
      setExtraProperties: setFaultExtraProperties
    }
  };
  componentDidMount(): void {
    /*if(this.props.pdApi.signalizationParameters === undefined && window.location.href.includes("signalization/parameters")){
      this.props.pdApiActions.fetchSignalizationParameters();
    }*/
    if(this.props.pdApi.signalizationFaults === undefined && window.location.href.includes("signalization/faults")){
      this.props.pdApiActions.fetchSignalizationFaults();
    }
  }
  render(): JSX.Element {
    const { subMenuRoute } = this.props;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const submenuLinks = Object.keys(this.subPages).map((subPageName: any) =>
      this.buildLink(subPageName)
    );
    const actionMenu = this.getActionMenu(subMenuRoute);
    const dataView = this.getDataView(subMenuRoute);
    const modal = this.buildModal();

    return (
      <>
        <ContentLayout submenu={submenuLinks} actionMenu={actionMenu} dataView={dataView} />
        {modal}
      </>
    );
  }

    private handleLinkClick = (subPageName: Api.AnyItem) => {
      this.props.editActions.cancelEditing;
      /*if(subPageName === "Signalization Parameters" && this.props.pdApi.signalizationParameters === undefined) {
        this.props.pdApiActions.fetchSignalizationParameters();
      }*/
      if(subPageName === "Signalization Faults" && this.props.pdApi.signalizationFaults === undefined) {
        this.props.pdApiActions.fetchSignalizationFaults();
      }

    };


  private setColumnFilters = (subMenuRoute: State.SignalizationSubmenu, newFilters: Filter[]): void => {
    const newFilterSet = { ...this.state.tableColumnFilters, [subMenuRoute]: newFilters };
    this.setState(prevState => ({
      ...prevState,
      tableColumnFilters: newFilterSet
    }));
  };

  private getDataView = (subMenuRoute: State.SignalizationSubmenu): JSX.Element => {
    if (subMenuRoute in this.subPages) {
      return React.createElement(this.subPages[subMenuRoute].dataView, {
        ...this.props,
        setColumnFilters: this.setColumnFilters,
        toggleModal: this.toggleModal
      });
    }
    return <>Error</>;
  };

  private getActionMenu = (subMenuRoute: State.SignalizationSubmenu): JSX.Element | null => (
    <ActionMenu
      {...this.props}
      itemName={this.subPages[subMenuRoute].itemName}
      groupName={this.groupName}
      selectedColumnsName={subMenuRoute}
      dataFieldName={this.subPages[subMenuRoute].PdApiField}
      setExtraProperties={this.subPages[subMenuRoute].setExtraProperties}
      createEmpty={this.subPages[subMenuRoute].createEmpty}
      columnFilters={this.state.tableColumnFilters[subMenuRoute]}
    />
  );

  private buildLink = (subPageName: State.SignalizationSubmenu): JSX.Element => {
    // To dynamically build urls we use the itenName and make it plural, so -s || -y => -ies
    let parsedLink = this.subPages[subPageName].itemName.replace(" ", "-");
    parsedLink = parsedLink.slice(-1) === "y" ? parsedLink.slice(0, -1) + "ies" : parsedLink + "s";
    return (
      <NavigationLink
        key={subPageName}
        handleOnClick={() => this.handleLinkClick(subPageName)}
        name={subPageName}
        to={"/" + this.groupName.toLowerCase() + "/" + parsedLink + "/"}
      />
    );
  };

  private buildModal = () => {
    const domainName = this.props.domainName ? " Domain: " + this.props.domainName : "";
    const content = (
      <span>
        Are you sure you want to delete this {this.subPages[this.props.subMenuRoute].itemName}?
        <br />
        {this.props.objectIdentifier}
        <br /> {domainName}
      </span>
    );

    return (
      <ConfirmationModal
        isOpen={this.state.isModalOpen}
        size="mini"
        header="Confirm delete"
        content={content}
        confirmText="Confirm"
        cancelText="Cancel"
        onConfirm={() =>
          this.props.editActions.delete(
            this.subPages[this.props.subMenuRoute].PdApiField as Api.OptionsGrud
          )
        }
        onCancel={this.toggleModal}
      />
    );
  };

  /*
   * Toggles the modal based on previous state.
   */
  private toggleModal = (): void => {
    this.setState(prevState => ({
      ...prevState,
      isModalOpen: !prevState.isModalOpen
    }));
  };
}

const mapStateToProps = (state: State.Root, ownProps: OwnProps) => ({
  fetchingStatus: state.main.fetchingStatus,
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isLoadingFaults: state.loadingStatus.isLoadingSignalizationFaults,
  isLoadingParameters: state.loadingStatus.isLoadingParameters,
  isEditActive: isEditActiveSelector(state.editView),
  editedObjectId: editedObjectIdSelector(state.editView),
  objectIdentifier: editedObjectIdentifierSelector(state.editView, ownProps.subMenuRoute),
  domainName: domainSelector(state.editView),
  toggleChildView: state.toggleChildView,
  filterOptions: state.filterOptions
});

const mapDispatchToProps = (dispatch: Dispatch<PdApiActions | ColumnActions | EditActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch),
  columnActions: bindActionCreators({ ...columnActions }, dispatch),
  editActions: bindActionCreators({ ...editActions }, dispatch),
  mainActions: bindActionCreators({ ...mainActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Signalization);
